import { render } from "./item-reward.vue?vue&type=template&id=19b27667&scoped=true"
import script from "./item-reward.js?vue&type=script&lang=js&external"
export * from "./item-reward.js?vue&type=script&lang=js&external"

import "./item-reward.vue?vue&type=style&index=0&id=19b27667&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19b27667"]])

export default __exports__